// 50 강사
// 100 지점관리자
// 500 최고관리자
const is_admin = async (login) => {
  let ret = false;
  // if (login.level === "50" || login.level === "100" || login.level === "500") {
  if (login.level === "100" || login.level === "500") {
    ret = true;
  }
  return ret;
};

export default is_admin;
